var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFunctionalFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6673 24.0003H21.334V21.3337H10.6673V24.0003ZM10.6673 18.667H21.334V16.0003H10.6673V18.667ZM8.00065 29.3337C7.26732 29.3337 6.63954 29.0725 6.11732 28.5503C5.5951 28.0281 5.33398 27.4003 5.33398 26.667V5.33366C5.33398 4.60033 5.5951 3.97255 6.11732 3.45033C6.63954 2.9281 7.26732 2.66699 8.00065 2.66699H18.6673L26.6673 10.667V26.667C26.6673 27.4003 26.4062 28.0281 25.884 28.5503C25.3618 29.0725 24.734 29.3337 24.0007 29.3337H8.00065ZM17.334 12.0003H24.0007L17.334 5.33366V12.0003Z",
    fill: "#3A7DE9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunctionalFilled);
export default __webpack_public_path__ + "static/media/FunctionalFilled.8ec8c1aaec2c823d1d3b1a12356a2321.svg";
export { ForwardRef as ReactComponent };